<template>
  <section class="section cv-search">
    <div class="cv-list-area">
      <div class="page-header">
        <h3 class="page-title">CV Search</h3>

        <p>
          <span>10</span>

          <span>/</span>

          <span>100</span>
        </p>
      </div>

      <div class="search-result">
        <ul>
          <li v-for="(i, index) in 10" :key="index">
            <div class="photo"></div>

            <div class="info">
              <h1>
                Anousone LUANGKHOT
                <a>Download CV</a>
              </h1>

              <p>
                Lastest Positon:
                <span>UX / UI Designer</span>
              </p>

              <p>
                Previous Job Title:
                <span>Graphic Designer</span>
              </p>

              <p>
                Previous Employer:
                <span>IT Software & Services </span>
              </p>

              <div class="see-more" v-if="seeMore">
                <p>
                  Previous Employer's Industry:
                  <span>Graphic Designer</span>
                </p>

                <p>
                  Education:
                  <span>Computer Science - Bachelor Degree</span>

                  <span>Business Administration - Bachelor Degree</span>
                </p>

                <p>
                  Language:
                  <span>English - Beginner</span>

                  <span>Chinese - Beginner</span>
                </p>

                <p>
                  Total Working Experience:
                  <span>5 Yrs</span>
                </p>
              </div>

              <a @click="seeMore = !seeMore">
                <span v-if="!seeMore">See more</span>

                <span v-if="seeMore">See less</span>
              </a>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="search-filter">
      <div class="field">
        <label class="label">Name</label>

        <div class="control">
          <input type="text" class="input" />
        </div>
      </div>

      <div class="field">
        <label class="label"> Total Working Experience</label>

        <div class="control">
          <input type="text" class="input" />
        </div>
      </div>

      <div class="field">
        <label class="label">Lastest Positon</label>

        <div class="control">
          <input type="text" class="input" />
        </div>
      </div>

      <div class="field">
        <label class="label">Lastest Salary</label>

        <div class="control">
          <input type="text" class="input" />
        </div>
      </div>

      <div class="field">
        <label class="label">Previous Job Title</label>

        <div class="control">
          <input type="text" class="input" />
        </div>
      </div>

      <div class="field">
        <label class="label">Previous Employer</label>

        <div class="control">
          <input type="text" class="input" />
        </div>
      </div>

      <div class="field">
        <label class="label">Previous Employer's Industry</label>

        <div class="control">
          <input type="text" class="input" />
        </div>
      </div>

      <div class="field">
        <label class="label">Field of Study</label>

        <div class="control">
          <input type="text" class="input" />
        </div>
      </div>

      <div class="field">
        <label class="label">Education Level</label>

        <div class="control">
          <input type="text" class="input" />
        </div>
      </div>

      <div class="field">
        <label class="label">Language</label>

        <div class="control">
          <input type="text" class="input" />
        </div>
      </div>

      <div class="field">
        <label class="label">Skill</label>

        <div class="control">
          <input type="text" class="input" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data: () => ({
    seeMore: false,
  }),
};
</script>

<style lang="scss" scoped>
.cv-search {
  display: flex;
  padding: 0 !important;
  overflow: hidden;
  .cv-list-area {
    flex-grow: 1;
    padding: 10px;
    display: flex;
    flex-direction: column;
    .page-header {
      border-bottom: 1px solid var(--border-color);
      padding-bottom: 10px;
      display: flex;
      justify-content: space-between;
      p span {
        &:nth-child(2) {
          padding: 0 5px;
          color: var(--grey-color);
        }
        &:nth-child(3) {
          color: var(--grey-color);
        }
      }
    }
    .search-result {
      width: 100%;
      overflow: auto;
      ul {
        list-style-type: none;
        margin: 0;
        padding: 0;
        width: 100%;
        li {
          border: 1px solid var(--border-color);
          padding: 10px;
          border-radius: 5px;
          display: flex;
          margin-bottom: 10px;
          .photo {
            min-width: 80px;
            min-height: 80px;
            max-width: 80px;
            max-height: 80px;
            background-image: url("https://upload.wikimedia.org/wikipedia/commons/thumb/4/45/Jackson_Wang_at_a_mini_fanmeeting_outside_%22Show%21_Music_Core%22_studios%2C_1_June_2019_02.jpg/330px-Jackson_Wang_at_a_mini_fanmeeting_outside_%22Show%21_Music_Core%22_studios%2C_1_June_2019_02.jpg");
            background-size: cover;
            background-position: center;
            border-radius: 5px;
            border: 1px solid var(--border-color);
            margin-right: 10px;
          }
          .info {
            h1 {
              font-size: var(--md-font);
              display: flex;
              align-items: center;
              margin-bottom: 5px;
              a {
                font-weight: 500;
                margin-left: 5px;
                color: var(--dark-grey-color);
                background-color: var(--light-grey-color);
                padding: 3px 10px;
                border-radius: 5px;
              }
            }
            p {
              margin: 0;
              color: var(--grey-color);
              font-size: var(--sm-font);
              span {
                color: var(--primary-color);
                &:not(:last-child) {
                  margin-right: 5px;
                  &::after {
                    content: ",";
                  }
                }
              }
            }
            a {
              font-size: var(--sm-font);
              margin: 0;
            }
          }
        }
      }
    }
  }
  .search-filter {
    width: 350px;
    border-left: 1px solid var(--border-color);
    padding: 20px;
    overflow: auto;
    * {
      font-size: var(--sm-font);
    }
    .field {
      margin-bottom: 8px;
      label {
        font-weight: 500;
        margin-bottom: 0;
      }
    }
  }
}
</style>
